/* eslint-disable linebreak-style */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// Antes de montar qualquer tela: o navegador só avisa uma vez que o sistema
// pode ser instalado (ver shared/pwa/instalacao.ts).
import './shared/pwa/instalacao';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Sistema instalável e abrindo sem internet (ver service-worker.ts e
// shared/offline). Service worker só no build de produção — em
// desenvolvimento ele atrapalharia o hot reload servindo arquivos em cache.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch((erro) => {
      console.error('Falha ao registrar o service worker:', erro);
    });
  });
}

// Pede ao navegador pra não apagar o banco local por falta de espaço — é
// nele que ficam as vendas feitas offline até serem enviadas.
navigator.storage?.persist?.().catch(() => undefined);



